import { Button, ButtonProps } from 'antd';

interface FilterButtonProps extends Omit<ButtonProps, 'onChange'> {
  disabledValue?: string[];
  value?: string[];
  onChange?: (value: string[]) => void;
}

const FilterButton = ({
  disabledValue = [],
  value = [],
  onChange,
  onClick,
  ...props
}: FilterButtonProps) => {
  return (
    <Button
      disabled={
        value.length === disabledValue.length && disabledValue.every((item) => value.includes(item))
      }
      size="small"
      type="link"
      onClick={(e) => {
        onChange && onChange(value);
        onClick && onClick(e);
      }}
      {...props}
    />
  );
};

export default FilterButton;
